import React, { useState } from 'react';

import { useConnectStore } from '../../../../../../store/models';
import CancelConnectPlanDialog from '.';

function useCancelConnectPlanDialog ({ planName, pricePerMonth } = {}) {
    const connectStore = useConnectStore();
    const [open, setOpen] = useState(false);

    // Cancellation always takes effect at the end of the *current* billing
    // cycle, so this date is already known before the mutation even runs.
    const nextRenewalDate = connectStore.currentPlan?.nextRenewalDate;

    async function onConfirm () {
        const result = await connectStore.cancelSubscription();
        if (!result || !result.error) {
            await connectStore.getCurrentPlan();
        }
        return result;
    }

    function renderCancelConnectPlanDialog () {
        if (!open) {
            return (<React.Fragment></React.Fragment>);
        }
        return (
            <CancelConnectPlanDialog
                open={open}
                onClose={() => {
                    setOpen(false);
                }}
                onConfirm={onConfirm}
                planName={planName}
                pricePerMonth={pricePerMonth}
                nextRenewalDate={nextRenewalDate}
            />
        );
    }

    function openDialog () {
        setOpen(true);
    }

    return {
        renderCancelConnectPlanDialog,
        openDialog,
    };
}

export default useCancelConnectPlanDialog;
